export enum Tenants {
    DataCutter = 0,
    Inrix = 1,
}